module.exports = __webpack_public_path__ + "img/tips.0b74caab.png";